// @ts-nocheck
import {
    OrderDetailsPaymentTermsStyles,
    paymentTermsStyles,
} from "@insite/content-library/Widgets/OrderDetails/OrderDetailsPaymentTerms";
import { infoProps } from "@store/Themes/common/props/info";

Object.assign<OrderDetailsPaymentTermsStyles>(paymentTermsStyles, {
    titleText: infoProps.label,
    termsText: infoProps.value,
});
